<template>
  <v-container id="regular-tables" fluid tag="section">
    <base-material-card icon="mdi-clipboard-text"
      :title="'Prospectar proyecto: ' + proyecto.codigo + ' - ' + proyecto.nombre" class="px-5 py-3">
      <v-container>
        <v-row>
          <v-col cols="6">
            <v-subheader>Frecuencia de visitas</v-subheader>
          </v-col>
          <v-col cols="6">
            <v-btn color="" elevation="2" small @click="dialogRegistrarVisita = true">
              Registrar visita
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-subheader>Contacto</v-subheader>
          </v-col>
          <v-col cols="6">
            <v-btn color="" elevation="2" small @click="dialogAgregarContacto = true">
              Agregar contacto
            </v-btn>
          </v-col>
        </v-row>

        <!-- TO-DO: Agregar el botón y la función de actualizar ubicación presente en producción -->

        <v-divider />
        <br>
        <v-form ref="formFinalizar" lazy-validation @submit.prevent="validateSubmitProspect">
          <v-row>
            <v-col cols="6">
              <v-file-input v-model="cotizacion" show-size label="Cotización (PDF o Excel) *" accept=".pdf,.xlsx,.xls"
                outlined required prepend-icon="mdi-file-pdf-box" />
            </v-col>

            <v-col cols="6">
              <v-file-input v-model="copiaCorreo" show-size label="Copia de correo al cliente (imagen) *"
                accept="image/*" outlined required prepend-icon="mdi-image" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-select v-model="metrados" :items="['no', 'sí']" label="Metrados" outlined required />
            </v-col>

            <v-col cols="6">
              <v-select v-model="planos" :items="['no', 'sí']" label="Planos" outlined required />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-file-input v-model="foto" show-size label="Foto del lugar (opcional)" accept="image/*" outlined
                prepend-icon="mdi-camera" />
            </v-col>

            <v-col cols="6">
              <v-textarea v-model="finalComment" label="Comentario *" outlined rows="4" required
                :rules="[v => !!v || 'Comentario es requerido']" />
            </v-col>
          </v-row>

          <v-btn type="submit" color="success" class="mr-4" :loading="isLoadingGuardar">
            Finalizar Prospección
          </v-btn>
        </v-form>

        <v-row justify="center">
          <v-dialog v-model="dialogFinalizarProspeccion" persistent max-width="500">
            <v-card>
              <v-card-title>
                ¿Está seguro de culminar la Etapa de Prospección?
              </v-card-title>
              <v-card-text>
                Una vez que se culmine la etapa de prospección (Planos: sí, Metrados: sí), el proyecto pasará a la etapa
                de aprobación y ya no será visible en este módulo. Deberá continuar en el módulo de Aprobación si le es
                asignado.
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="green darken-1" text @click="dialogFinalizarProspeccion = false">
                  Cancelar
                </v-btn>
                <v-btn color="green darken-1" text :loading="isLoadingGuardar" @click="submitProspect()">
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </base-material-card>


    <v-row justify="center">
      <v-dialog v-model="dialogRegistrarVisita" persistent max-width="600px">
        <v-card>
          <v-card-title><span>Registrar visita</span></v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-form ref="form2" v-model="valid2" lazy-validation @submit.prevent="prospectData()">
                    <v-text-field v-model="asunto" label="Asunto de reunión"
                      :rules="[v => !!v || 'Asunto es requerido']" outlined />
                    <v-textarea v-model="comentario" label="Comentario" :rules="[v => !!v || 'Comentario es requerido']"
                      outlined />
                    <v-select v-model="eficaz" label="¿Presentación eficaz?" :rules="[v => !!v || 'Requerido']"
                      :items="['Sí', 'No']" required outlined />
                    <v-btn @click="dialogRegistrarVisita = false">
                      Cerrar
                    </v-btn>
                    <v-btn color="primary" type="submit" :loading="isLoadingVisitas">
                      Guardar
                    </v-btn>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
            <small>*Se registrará visita</small>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialogAgregarContacto" persistent max-width="600px">
        <v-card>
          <v-card-title><span>Agregar contacto</span></v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="addContact()">
                <v-select v-model="newContact.associated" label="Asociado a:" :rules="[v => !!v || 'Item requerido']"
                  :items="[proyecto.inmobiliaria, proyecto.constructora]" outlined />
                <v-text-field v-model="newContact.contactName" label="Nombre de contacto"
                  :rules="[v => !!v || 'Requerido']" outlined />
                <v-text-field v-model="newContact.contactTelephone" outlined label="Teléfono corporativo"
                  :rules="[v => !!v || 'Requerido']" max="9" />
                <v-text-field v-model="newContact.contactTelephone2" outlined label="Teléfono personal"
                  :rules="[v => !!v || 'Requerido']" max="9" />
                <v-text-field v-model="newContact.addressContact" outlined label="Dirección de oficina"
                  :rules="[v => !!v || 'Requerido']" />
                <v-text-field v-model="newContact.emailContact" outlined label="Email personal"
                  :rules="[v => !!v || 'Requerido']" />
                <v-text-field v-model="newContact.emailContact2" outlined label="Email corporativo"
                  :rules="[v => !!v || 'Requerido']" />
                <v-text-field v-model="newContact.positionContact" outlined label="Cargo"
                  :rules="[v => !!v || 'Requerido']" />
                <v-btn @click="dialogAgregarContacto = false">
                  Cerrar
                </v-btn>
                <v-btn color="primary" type="submit" :loading="isLoadingContacto">
                  Guardar
                </v-btn>
              </v-form>
            </v-container>
            <small>*Se registrará el contacto</small>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="isSuccessDialogVisible" persistent max-width="400">
        <v-card>
          <v-card-title class="text-success font-weight-bold">Prospección completada</v-card-title>
          <v-card-text>El proyecto fue guardado exitosamente y enviado a Aprobación.</v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    
  </v-container>
</template>
<script>
import firebase from 'firebase'
//import axios from 'axios'
import date from 'date-and-time'


export default {
  data() {
    return {
      finalComment: "",
      valid2: true,
      valid: true,
      foto: null,
      planos: 'no',
      metrados: 'no',
      cotizacion: null,
      copiaCorreo: null,
      asunto: '',
      eficaz: null,
      comentario: '',
      proyecto: '',
      isLoadingVisitas: false,
      isLoadingContacto: false,
      isLoadingGuardar: false,
      isSuccessDialogVisible:false,
      dialogRegistrarVisita: false,
      dialogAgregarContacto: false,
      dialogFinalizarProspeccion: false,
      faseProyecto: 1,
      newContact: [],
      estadoAprobación: "Por aprobar",
    }
  },
  computed: {
    currentDate() {
      const now = new Date()
      return String(date.format(now, 'YYYY/MM/DD HH:mm:ss'))
    },
  },
  mounted() {
    if (this.$store.state.prospectarData === null) {
      this.$router.push('/proyectos/prospeccion/prospeccion')
    }
    this.proyecto = this.$store.state.prospectarData
    this.planos = this.proyecto.planos
    this.metrados = this.proyecto.metrados
  },
  methods: {
    async prospectData() {
      const result = await this.$refs.form2.validate()
      if (result) {
        if (!this.proyecto || !this.proyecto.codigo) {
          console.error('Proyecto inválido')
          return
        }

        this.isLoadingVisitas = true
        const db = firebase.firestore().collection('proyectos').doc(this.proyecto.codigo)

        try {
          await db.set({
            visitas: firebase.firestore.FieldValue.arrayUnion({
              fecha_creacion: this.formatoFecha(),
              asunto: this.asunto,
              comentario: this.comentario,
              eficaz: this.eficaz,
            }),
          }, { merge: true })

          this.dialogRegistrarVisita = false
          this.isLoadingVisitas = false
          this.$refs.form2.reset()
        } catch (error) {
          console.error('Error al registrar visita:', error)
          this.isLoadingVisitas = false
        }
      }
    },
    async addContact() {
      const result = await this.$refs.form.validate()
      if (result) {
        this.isLoadingContacto = true

        try {
          const newContactRef = firebase.firestore().collection('contacts').doc(this.newContact.associated)
          const tipo = this.proyecto.construye === this.newContact.associated ? 1 : 2

          await newContactRef.set({
            type: tipo,
            contactos: firebase.firestore.FieldValue.arrayUnion({
              associated: this.newContact.associated,
              createdAt: this.formatoFecha(),
              contactName: this.newContact.contactName,
              contactTelephone: this.newContact.contactTelephone,
              contactTelephone2: this.newContact.contactTelephone2,
              addressContact: this.newContact.addressContact,
              emailContact: this.newContact.emailContact,
              emailContact2: this.newContact.emailContact2,
              positionContact: this.newContact.positionContact,
            }),
          }, { merge: true })

          this.dialogAgregarContacto = false
          this.isLoadingContacto = false
          this.$refs.form.reset()
        } catch (error) {
          console.error('Error al agregar contacto:', error)
          this.isLoadingContacto = false
        }
      }
    },
    formatoFecha() {
      const fecha = new Date()
      const formato = 'dd/mm/yy'
      const map = {
        dd: fecha.getDate(),
        mm: fecha.getMonth() + 1,
        yy: fecha.getFullYear().toString().slice(-2),
        yyyy: fecha.getFullYear(),
      }
      return formato.replace(/dd|mm|yy|yyyy/gi, matched => map[matched]) +
        ' ' + fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds()
    },
    validateSubmitProspect() {
      if (this.planos === 'sí' && this.metrados === 'sí') {
        this.dialogFinalizarProspeccion = true
        this.faseProyecto = 2
      } else {
        alert("Planos y metraje deben estar marcados con SI")
      }
    },
    async submitProspect() {
      this.isLoadingGuardar = true;

      const allowedExtensions = [
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/webp'
      ];

      function checkFileExtension(archivo) {
        return archivo && allowedExtensions.includes(archivo.type);
      }

      function nombreConTimestamp(archivo, carpeta) {
        const timestamp = Date.now();
        return `${carpeta}/${timestamp}_${archivo.name.replace(/\s+/g, '_')}`;
      }


      if (!this.cotizacion || !this.copiaCorreo) {
        alert('Es necesario adjuntar la cotización y la copia del correo de confirmación.');
        this.isLoadingGuardar = false;
        return;
      }

      if (!checkFileExtension(this.cotizacion)) {
        alert(`Archivo de cotización no permitido. Tipo detectado: ${this.cotizacion.type}`);
        this.isLoadingGuardar = false;
        return;
      }

      if (!checkFileExtension(this.copiaCorreo)) {
        alert(`Archivo de correo no permitido. Tipo detectado: ${this.copiaCorreo.type}`);
        this.isLoadingGuardar = false;
        return;
      }

      if (!this.finalComment) {
        alert('El comentario es OBLIGATORIO');
        this.isLoadingGuardar = false;
        return;
      }

      try {

        const cotizacionPath = nombreConTimestamp(this.cotizacion, 'cotizaciones');
        const cotizacionSnapshot = await firebase.storage().ref().child(cotizacionPath).put(this.cotizacion);
        const cotizacionUrl = await cotizacionSnapshot.ref.getDownloadURL();

        const correoPath = nombreConTimestamp(this.copiaCorreo, 'correos');
        const correoSnapshot = await firebase.storage().ref().child(correoPath).put(this.copiaCorreo);
        const correoUrl = await correoSnapshot.ref.getDownloadURL();

        let fotoUrl = null;
        if (this.foto !== null) {
          if (!checkFileExtension(this.foto)) {
            alert(`La imagen debe ser PDF, Excel, JPG o PNG. Tipo detectado: ${this.foto.type}`);
            this.isLoadingGuardar = false;
            return;
          }
          const fotoPath = nombreConTimestamp(this.foto, 'photos');
          const fotoSnapshot = await firebase.storage().ref().child(fotoPath).put(this.foto);
          fotoUrl = await fotoSnapshot.ref.getDownloadURL();
        }

        const docRef = firebase.firestore().collection('proyectos').doc(this.proyecto.codigo);
        const usuario = JSON.parse(localStorage.userAuth).email;
        const now = firebase.firestore.Timestamp.fromDate(new Date());

        const comentarios = [
          {
            usuario: usuario,
            createdAt: now,
            comment: "⚙️ El proyecto pasó de la fase de prospección a la fase de aprobación."
          },
          {
            usuario: usuario,
            createdAt: now,
            comment: this.finalComment.trim()
          }
        ];

        const dataToUpdate = {
          planos: this.planos,
          metrados: this.metrados,
          estadoNegociacion: 'POR COTIZAR',
          fase: this.faseProyecto,
          foto: fotoUrl,
          cotizacion: cotizacionUrl,
          copiaCorreo: correoUrl,
          propectadoAt: this.currentDate,
          quienProspecto: usuario,
          estadoAprobacion: firebase.firestore.FieldValue.arrayUnion('Por aprobar'),
          comments: firebase.firestore.FieldValue.arrayUnion(...comentarios)
        };

        await docRef.set(dataToUpdate, { merge: true });

        await this.logAutomaticComment(this.proyecto.codigo, 
        "⚙️ El proyecto pasó de la fase de prospección a la fase de aprobación.", this.proyecto);

        this.isLoadingGuardar = false;

        this.isSuccessDialogVisible = true;

        this.sendEmail()
        setTimeout(() => {
          this.isSuccessDialogVisible = false;
          this.$router.push('/proyectos/prospeccion/prospeccion');
        }, 1300);

      } catch (error) {
        console.error('Error al guardar prospección:', error);
        this.isLoadingGuardar = false;
      }
    },
    logAutomaticComment(codigo, comentario, proyectoData) {
      const user = JSON.parse(localStorage.userAuth);
      const logData = {
        codigoProyecto: codigo,
        nombreProyecto: proyectoData.nombre || '',
        comentario: comentario,
        usuario: user.email,
        perfil: user.perfil,
        fecha: firebase.firestore.Timestamp.fromDate(new Date()),
        estadoNegociacion: proyectoData.estadoNegociacion || '',
        constructora: proyectoData.constructora || '',
        inmobiliaria: proyectoData.inmobiliaria || '',
        tipo: proyectoData.tipo || '',
        region: proyectoData.region || '',
        provincia: proyectoData.provincia || '',
        fase: proyectoData.fase || 1,
        asesor: proyectoData.asesor || user.email,
        prospector: proyectoData.prospector || user.email
      };

      return firebase.firestore().collection('globalLog').add(logData);
    },

    async sendEmail() {
      console.log('body', this.proyecto.nombre, this.proyecto.asesor);
      try {
        const response = await fetch('https://enviarcorreoproyecto-jxlprw2bsa-uc.a.run.app', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nombre: this.proyecto.nombre,
            asesor: this.proyecto.asesor
          })
        });

        if (!response.ok) {
          const error = await response.json();
          console.error('Error en el envío:', error);
        } else {
          const data = await response.json();
          console.log('Respuesta del servidor:', data);
        }
      } catch (err) {
        console.error('Error de red o CORS:', err);
      }
    }

  },
}
</script>


